import React from 'react'
import styles from './RedirectApps.module.sass'

export default function RedirectApps() {
    return (
        <div className={styles.mainBox}>
            <div className={styles.box}>
                <h1>Para continuar, descarga nuestra aplicación</h1>
                <br></br>
                <div className={styles.contApp}>
                    <div className={styles?.claroAppLogo}></div>
                    <p>Disponible en:</p>
                    <div className={styles?.contLinksStore}>
                        <a href="https://play.google.com/store/apps/details?id=com.americamovil.claroshop" className={styles?.android}></a>
                        <a href="https://apps.apple.com/mx/app/claro-shop/id1057314145" className={styles?.ios}></a>
                    </div>
                </div>
            </div>
        </div>
    )
}